import { NgModule } from '@angular/core';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
//import { Produto, Categoria, Adicionais } from '../cardapio';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertaConfirmDialog } from '../alerta-confirm';
import {AlertaSimplesDialog } from '../alerta-simples';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import * as moment from 'moment';
import { Observable } from '../../../node_modules/rxjs';
import { ThrowStmt } from '@angular/compiler';
// import * as qq from "../../assets/js/radialmenu";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
  })

export class HomeComponent implements OnInit, OnDestroy {
    shouldHide: boolean = true;
    shouldHide2: boolean = false;
    shouldHide3: boolean = true;
    produtoSelecionado: any[]  = [];
    inputsearch: any = '';
    contadorAdmin: any = 0;
    hideCL: boolean = false;
    tipoMenu: any = 0;
    diaAtual: any = '';
    diaDS: any = 0;
    dataFull: any = '';
    urlFoto: any = '';
    minhaFoto: any = '';
    imPro: boolean = false;
    qtdMsgChat: number = 0;
    qtdNotify: number = 0;
    imPremium: boolean = false;
    meuSO: any = '';
    avoidP: boolean = true;
    avoidM: boolean = true;
    constructor( public tmaService: TamasAlunoService,private route: ActivatedRoute, public router: Router, public dialog: MatDialog) {
        //this.qtdMsgChat = this.tmaService.hcChatMsg;
    }

    ngOnInit() {
        this.qtdMsgChat = this.tmaService.hcChatMsg;
        this.tmaService.chatQtyChange.subscribe((value) =>{
            //this.hcChatMsg = value;
            console.log("changed");
            this.qtdMsgChat = this.tmaService.hcChatMsg;
          })

        console.log("qtd notificações " + this.qtdNotify);
        this.qtdNotify = this.tmaService.hcNotify;
        this.tmaService.notifyQtyhange.subscribe((value) =>{
            //this.hcChatMsg = value;
            console.log("changed");
            this.qtdNotify = this.tmaService.hcNotify;
          })

        if(this.tmaService.hcEtapa != 8){
            //não poderia estar aqui
            if(this.tmaService.forceLogout() == true){
                this.router.navigate(['/login']);
            }
            
        }
        else{
            if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' || this.tmaService.hcWA && this.tmaService.hcSO == 'android'){
                this.avoidP = true;
                this.avoidM = true;
            }
            else{
                this.avoidP = false;
                this.avoidM = false;
            }

            // if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios' && !this.tmaService.hcPremium){
            //     this.avoidM = true;
            // }
            // else{
            //     this.avoidM = false;
            // }

            if(this.tmaService.intervalAllChat == ''){
                this.tmaService.criarIntervalChat();
            }
            if(this.tmaService.intervalNotify == ''){
                this.tmaService.criarIntervalNotify();
            }
            moment.locale('pt');
            this.tmaService.eventoFS(false);
            this.hideCL = true;
            this.tipoMenu = +this.route.snapshot.paramMap.get('qq');
            //var dataTeste = moment(new Date()).format("DD/MM/YYYY");
            var dataTeste = moment();
            this.diaAtual = moment(dataTeste, 'DD/MM/YYY').date();
            this.diaDS = dataTeste.day();
            this.dataFull = dataTeste.format('DD-MM-YYYY');
            this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
            this.minhaFoto = this.tmaService.hcFoto;
            console.log("chamada home");
            console.log(this.tmaService.hcPremium);
            this.imPremium = this.tmaService.hcPremium;
            if(this.tmaService.hcProAtivo && this.tmaService.hcIsPro){
                this.imPro = true;
            }
            //obter isso de alguma forma (storage sei lá)
    
            setTimeout(() => {
                this.loadScript('../../assets/js/radialmenu.js');
            }, 0);
        }
       
    }

    public loadScript(url: string) {
        const body = <HTMLDivElement> document.body;
        const script = document.createElement('script');
        script.innerHTML = '';
        script.type = 'text/javascript';
        script.src = url;
        script.async = false;
        script.defer = true;
        body.appendChild(script);
      }

    ngOnDestroy(){
        this.tmaService.gUrlAnterior = 'home';
    }

    goReceitas() :void{
        this.router.navigate(['/me/receitas']);
    }
    
    goDietaDia() :void{
        //obter parametros do servidor da dieta favorita e tal, talvez logo que carregar a home trazer isso
        //data de hj
        console.log(this.diaAtual);
        if(this.tmaService.hcDietaFix == 0){
            //sem dietas
            this.router.navigate(['/me/dietas']);
        }   
        else{
            this.tmaService.paginaAnterior = "home";
            this.router.navigate(['/me/cardapio/' + this.tmaService.hcDietaFix + '/' + this.diaDS + '/' + this.dataFull ]);
        }
        //var idDieta = 1;
        //var dataFormatada = this.diaAtual.toLocaleDateString()
        
    }
    goTreinoAtual() :void{
        //obter isso do servidor
        if(this.tmaService.hcTreinoFix == 0){
            this.router.navigate(['/me/treinos']);
        }
        else{
            this.tmaService.paginaAnterior = "home";
            this.router.navigate(['/me/fichatreino/' + this.tmaService.hcTreinoFix]);
        }

        //var idFicha = 1;
      
    }


    goPerfil() {
        this.router.navigate(['/' + this.tmaService.hcNomeUsuario]);
    }

    goAvaliacoes() {
        this.router.navigate(['/me/avaliacoes']);

    }
    goCFG() {
        this.router.navigate(['/me/settings']);

    }
    detalhesRefeicao(idDieta: any , diaSemana: any, idRefeicao: any, diaMes: any) :void{
        this.tmaService.qPagina = "home";
        this.router.navigate(['/me/refeicao/' + idDieta + "/" + diaSemana + "/" + idRefeicao + "/" + diaMes]);
    }
    
    goConquistas() :void{
        this.router.navigate(['/' + this.tmaService.hcNomeUsuario + '/conquistas']);
    }
    goLoja() :void{
        if(this.tmaService.shopCidade != ''){
            this.router.navigate(['shop/' + this.tmaService.shopUF + '/' + this.tmaService.shopCidade]);
        }
        else{
            this.router.navigate(['pre-shop/uf']);
        }
    }

    goPedidos() :void{
        this.router.navigate(['/shopping/pedidos']);
    }

    goInbox(){
        //alert("not yet");
        //this.router.navigate(['/me/inbox'], {replaceUrl: true});
        this.router.navigate(['/me/inbox'], {replaceUrl: false});
    }

    goDashboard() :void{
        if(this.tmaService.hcPremium){
           this.router.navigate(['/dashboard/home/']);
        }
        else{
            if(this.tmaService.hcWA && this.tmaService.hcSO == 'ios'){
                //do nothing
            }
            else{
                //ok go
                const dialogRefConf = this.dialog.open(AlertaConfirmDialog, {
                    width: '300px',
                    data: { tituloAlerta: "Premium", textoAlerta: "Esta é uma funcionalidade exclusiva para usuários premium. Deseja saber mais sobre os benefícios?", textoCancel: "Não", textoConfirm: "SIM" }
                  });
                  dialogRefConf.afterClosed().subscribe(result => {
                    if (result == true) {
                      this.router.navigate(['/premium']);
                    }
                  });
            }
        
        }
    }

    goPremium() :void{
        this.router.navigate(['/premium']);
        
        
    }

    meuPremium() :void{
        //call server 
        let customParams = {
            //lista: localStorage.getItem('turboCart'),
            email: this.tmaService.hcEmail,
            senha: this.tmaService.hcSenha
          };
          this.hideCL = false;
          this.tmaService.infoMeuPremium(customParams).subscribe((qRes) =>{
            this.hideCL = true;
            console.log(qRes);
            if(qRes['res'] == 'done'){
                const dialogRefConf = this.dialog.open(AlertaConfirmDialog, {
                    width: '300px',
                    data: { tituloAlerta: "Premium", textoAlerta: "Sua assinatura premium é válida até dia " + qRes['dataExp'] + ", deseja visualizar os planos de assinatura?", textoCancel: "Não", textoConfirm: "SIM" }
                  });
                  dialogRefConf.afterClosed().subscribe(result => {
                    if (result == true) {
                      this.router.navigate(['/premium']);
                    }
                  });
            }
            else{
              const erroCriar = this.dialog.open(AlertaSimplesDialog, {
                disableClose:true,
                data: {textoAlerta: "Ocorreu um erro ao obter as informações. Tente novamente", iconAlerta: 'warning'}
              });
            }
          },
          (error) =>{
            this.hideCL = true;
            const erroCriar = this.dialog.open(AlertaSimplesDialog, {
              disableClose:true,
              data: {textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning'}
            });
          })

       
    }


    goNotificacoes() :void{
        this.router.navigate(['/me/notificacoes']);
    }
}
